import axios from 'axios';

const PropertyVendorService = {
  async createPropertyVendor({ formValues, propertyId }) {
    const values = {
      ...formValues,
      property_id: propertyId,
    };

    const response = await axios.post('/property_vendor', values);

    return response.data;
  },

  async deletePropertyVendor(propertyVendorId) {
    const response = await axios.delete(`/property_vendor/${propertyVendorId}`);

    return response.data;
  },

  async updatePropertyVendor({ formValues, propertyVendorId }) {
    const response = await axios.put(
      `/property_vendor/${propertyVendorId}`,
      formValues
    );

    return response.data;
  },
};

export default PropertyVendorService;
